import { CircularProgress } from '@mui/material'

const LoadingOverlay = () => (
  <div className="absolute left-0 top-0 z-[1200] flex h-full w-full items-center justify-center bg-gray-500 bg-opacity-50">
    <CircularProgress />
  </div>
)

export default LoadingOverlay
